import { EarningsState } from './state';
import Dinero from 'dinero.js';

export const earningsInitialState: EarningsState = {
  data: {
    ARTIST: [],
    OWNER: [],
    DEAL: [],
  },
  pendingEntries: {
    ARTIST: [],
    OWNER: [],
    DEAL: [],
  },
  eligibleEntries: {
    ARTIST: [],
    OWNER: [],
    DEAL: [],
  },
  total: {
    ARTIST: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
    OWNER: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
  },
  pending: {
    ARTIST: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
    OWNER: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
    DEAL: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
  },
  available: {
    ARTIST: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
    OWNER: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
    DEAL: Dinero({ amount: 0, currency: 'USD', precision: 5 }),
  },
  streams: {
    ARTIST: 0,
    OWNER: 0,
    DEAL: 0,
  },
  downloads: {
    ARTIST: 0,
    OWNER: 0,
    DEAL: 0,
  },
  upcs: {
    ARTIST: 0,
    OWNER: 0,
    DEAL: 0,
  },
  pendingStart: {
    ARTIST: new Date(),
    OWNER: new Date(),
    DEAL: new Date(),
  },
  pendingEnd: {
    ARTIST: new Date(),
    OWNER: new Date(),
    DEAL: new Date(),
  },
  exportUrl: '',
  exportStatus: '',
};
